import Vue from 'vue'
//页面内翻页
const innerPagination = Vue.extend({
  template: `
  <div v-if="all>0" class="inner-pagination ht-80 d-flex align-items-center justify-content-center">
      <div v-if="page_size_select" class=" d-flex align-items-center flex-1">
        <span class=" mg-r-5">{{$t("outside.每页")}}</span>
        <select class="form-control pagination-select form-control-dark max-w-70 mg-r-5" v-model="rowsPerPage" @change="changerpPage">
          <option v-for="val in page_size_select" :value="val">{{val}}</option>
        </select>
        <span>{{$t("outside./条，共")}}<span class=" tx-info">{{total_count}}</span> {{$t("outside.条")}}</span>
      </div>
      <nav class="flex-1" aria-label="Page navigation">
          <ul class="pagination pagination-basic mg-b-0">
          <li v-if="showPre" class="page-item">
              <a href="javascript:;" class="page-link wd-60" style="white-space: nowrap;width: auto !important;" @click="getPage(cur - 1)" aria-label="Last" title="前一页">
              {{$t("outside.前一页")}}
              </a>
          </li>
          <li v-if="showFirst" class="page-item">
            <a href="javascript:;" class="page-link" @click="getPage(1)" aria-label="Next" title="第一页">
              1
            </a>
          </li>
          <li v-if="showFirst && showFirstEllipsis" class="page-item disabled"><span class="page-link">...</span></li>
          <li v-for="index in indexs" class="page-item" :class="{active: cur == index}"><a href="javascript:;" class="page-link" @click="getPage(index)">{{index}}</a></li>
          <li v-if="showLast && showLastEllipsis" class="page-item disabled"><span class="page-link">...</span></li>
          <li v-if="showLast" class="page-item">
            <a href="javascript:;" class="page-link" @click="getPage(all)" aria-label="Last" title="最后一页">
              {{this.all}}
            </a>
          </li>
          <li v-if="showNext" class="page-item">
            <a href="javascript:;" class="page-link wd-60" style="white-space: nowrap;width: auto !important;" @click="getPage(parseInt(cur) + 1)" aria-label="Next" title="后一页">
            {{$t("outside.后一页")}}
            </a>
          </li>
          <li v-if="all>1" class="page-item">
              <input class="wd-60 form-control form-control-dark" type="text" size="2" v-model="toPage" @keyup.enter="gotoPage">
            </li>
            <li v-if="all>1" class="page-item">
              <a class="page-link bg-info" href="javascript:;" @click="gotoPage">GO</a>
            </li>
          </ul>
      </nav>
      </div>
`,
  props: ['cur', 'all', 'size', 'page_size_select', 'rows_per_page', 'total_count'],
  data(){
    return {
      rowsPerPage: '',
      toPage: ''
    }
  },
  created(){
    this.rowsPerPage = this.rows_per_page;
  },
  watch: {
    rows_per_page: function(){
      this.rowsPerPage = this.rows_per_page;
    }
  },
  computed: {
    indexs: function () {
      let size = 7; //默认尺寸
      if(this.size){
        size = this.size;
      }
      let ar = [];
      let left, right;
      if (this.cur <= (size+1)/2) {
        for (let i = 1; i < size+1; i++) {
          ar.push(i)
          if (i >= this.all) break;
        }
      } else {
        left = right = this.cur;
        for (let i = 0; i < (size+1)/2; i++) {
          ar.unshift(left--)
          if (left <= 1) break;
        }
        for (let i = 0; i < (size+1)/2-1; i++) {
          if (right >= this.all) break;
          right++
          ar.push(right)

        }
      }
      return ar;
    },
    showLast: function () {
      let size = 7; //默认尺寸
      if(this.size){
        size = this.size;
      }
      if (this.all <= (size)/2+2 || this.all<=size) return false;
      if (this.cur >= this.all - (size/2)) return false;
      return true;
    },
    showFirst: function () {
      let size = 7; //默认尺寸
      if(this.size){
        size = this.size;
      }
      if (this.cur == 1 || this.cur < (size/2 + 1)) {
        return false;
      }
      return true;
    },
    showFirstEllipsis(){
      let size = 7; //默认尺寸
      if(this.size){
        size = this.size;
      }
      if(this.cur > size/2+2){
        return true;
      }
      return false;
    },
    showLastEllipsis(){
      let size = 7; //默认尺寸
      if(this.size){
        size = this.size;
      }
      if(this.all<=size+1) return false;
      if(this.cur < (this.all - size/2-1)){
        return true;
      }
      return false;
    },
    showPre(){
      if(this.cur>1){
        return true;
      }
      return false;
    },
    showNext(){
      if(this.cur<this.all){
        return true;
      }
      return false;
    }
  },
  methods: {
    getPage(page) {
      this.$emit('page', page);
    },
    gotoPage() {
      let page = parseInt(this.toPage);
      if(page){
        page = this.toPage = page > this.all ? this.all : page;
        this.$emit('page',page)
      }
      this.toPage = ''; 
    },
    changerpPage(){
      this.$emit('changeRPPage',this.rowsPerPage);
    }
  }
})
//路由翻页
const pagination = Vue.extend({
  template: `
  <div v-if="all>0" class="ht-80 d-flex align-items-center justify-content-center">
      <div v-if="page_size_select" class=" d-flex align-items-center flex-1">
        <span class=" mg-r-5">{{$t("outside.每页")}}</span>
        <select class="form-control pagination-select form-control-dark max-w-70 mg-r-5" v-model="rowsPerPage" @change="changerpPage">
          <option v-for="val in page_size_select" :value="val">{{val}}</option>
        </select>
        <span>{{$t("outside./条，共")}}<span class=" tx-info">{{total_count}}</span> {{$t("outside.条")}}</span>
      </div>
      <nav class=" flex-1" aria-label="Page navigation">
          <ul class="pagination pagination-basic mg-b-0 justify-content-center">
            <li v-if="showPre" class="page-item">
              <router-link :to="{path: path + (cur - 1), query: $route.query}"class="page-link wd-60" style="white-space: nowrap;width: auto !important;" aria-label="Last" title="前一页">
              {{$t("outside.前一页")}}
              </router-link>
            </li>
            <li v-if="showFirst" class="page-item">
              <router-link :to="{path: path + 1, query: $route.query}" href="javascript:;" class="page-link"  aria-label="Next" title="第一页">
                1
              </router-link>
            </li>
            <li v-if="showFirst && showFirstEllipsis" class="page-item disabled"><span class="page-link">...</span></li>
            <li v-for="index in indexs" class="page-item" :class="{active: cur == index}">
              <router-link  :to="{path: (path + index),query: $route.query}" class="page-link">
                {{index}}
              </router-link>
            </li>
            <li v-if="showLast && showLastEllipsis" class="page-item disabled"><span class="page-link">...</span></li>
            <li v-if="showLast" class="page-item">
              <router-link :to="{path: path + all, query: $route.query}" class="page-link" aria-label="Last" title="最后一页">
                {{this.all}}
              </router-link>
            </li>
            <li v-if="showNext" class="page-item">
              <router-link :to="{path: path + (parseInt(cur) + 1), query: $route.query}" class="page-link wd-60" style="white-space: nowrap;width: auto !important;" aria-label="Next" title="后一页">
              {{$t("outside.后一页")}}
              </router-link>
            </li>
            <li v-if="all>1" class="page-item">
              <input class="wd-60 form-control form-control-dark" type="text" size="2" v-model="toPage" @keyup.enter="gotoPage">
            </li>
            <li v-if="all>1" class="page-item">
              <a class="page-link bg-info" href="javascript:;" @click="gotoPage">GO</a>
            </li>
          </ul>
      </nav>
      <div v-if="page_size_select" class="flex-1"></div>
      </div>
`,
  props: ['cur', 'all', 'size', 'path', 'page_size_select', 'rows_per_page', 'total_count'],
  data(){
    return {
      rowsPerPage: '',
      toPage: ''
    }
  },
  created(){
    this.rowsPerPage = this.rows_per_page;
  },
  mounted(){
    if(!this.page_size_select.includes(this.rowsPerPage, 0)){
      this.rowsPerPage = this.page_size_select[0];
      this.$emit('changeRPPage',this.rowsPerPage);
    }
  },
  watch: {
    rows_per_page: function(){
      this.rowsPerPage = this.rows_per_page;
    },
  },
  computed: {
    indexs: function () {
      let size = 7; //默认尺寸
      if(this.size){
        size = this.size;
      }
      let ar = [];
      let left, right;
      if (this.cur <= (size+1)/2) {
        for (let i = 1; i < size+1; i++) {
          ar.push(i)
          if (i >= this.all) break;
        }
      } else {
        left = right = this.cur;
        for (let i = 0; i < (size+1)/2; i++) {
          ar.unshift(left--)
          if (left <= 1) break;
        }
        for (let i = 0; i < (size+1)/2-1; i++) {
          if (right >= this.all) break;
          right++
          ar.push(right)
        }
      }
      return ar;
    },
    showLast: function () {
      let size = 7; //默认尺寸
      if(this.size){
        size = this.size;
      }
      if (this.all <= (size)/2+2 || this.all<=size) return false;
      if (this.cur >= this.all - (size/2)) return false;
      return true;
    },
    showFirst: function () {
      let size = 7; //默认尺寸
      if(this.size){
        size = this.size;
      }
      if (this.cur == 1 || this.cur < (size/2 + 1)) {
        return false;
      }
      return true;
    },
    showFirstEllipsis(){
      let size = 7; //默认尺寸
      if(this.size){
        size = this.size;
      }
      if(this.cur > size/2+2){
        return true;
      }
      return false;
    },
    showLastEllipsis(){
      let size = 7; //默认尺寸
      if(this.size){
        size = this.size;
      }
      if(this.all<=size+1) return false;
      if(this.cur < (this.all - size/2-1)){
        return true;
      }
      return false;
    },
    showPre(){
      if(this.cur>1){
        return true;
      }
      return false;
    },
    showNext(){
      if(this.cur<this.all){
        return true;
      }
      return false;
    }
  },
  methods:{
    changerpPage(){
      this.$emit('changeRPPage',this.rowsPerPage);
    },
    gotoPage(){
      let page = parseInt(this.toPage);
      if(page){
        page = this.toPage = page > this.all ? this.all : page;
        this.$emit('gotoPage',page)
      }
      this.toPage = ''; 
    }
  }
})

export {innerPagination, pagination};